import React, { useContext } from 'react';

import { Minimize } from './MinimizeBtn.styles';

import { PlayerContext } from '../../../contexts/player.context';

const MinimizeBtn = ({ className }) => {
  const { setMinimized } = useContext(PlayerContext);
  return <Minimize className={className} onClick={setMinimized} />;
};

export default MinimizeBtn;
